import { strCode } from "../localizations/strCode";

const certificateErrors = {
  REQUEST_BODY_IS_NOT_PROVIDED: strCode.REQUEST_BODY_IS_NOT_PROVIDED,
  INVALID_DUSN_VALUE: strCode.INVALID_DUSN_VALUE
};

export default certificateErrors;
